import React from "react";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import Header from "../../Components/Header";
import AdminOverviewCardParent from "../../Components/IBAAdmin/AdminOverviewCardParent";
import AccountOpenBarChart from "../../Components/IBAAdmin/AccountOpenBarChart";
import TopPerformerCardAdminParent from "../../Components/IBAAdmin/TopPerformerCardAdminParent";
import AgentList from "../../Components/IBAAdmin/AgentList";

function PayoutApproval() {
    let payoutheader = {
        agentName: "Agent Name",
        talktime: "Talktime (in minutes)",
        accountopened: "Accounts Opened",
        totalPayout: "Total Payout"
    };

    return (
        <>
            <Header portal={"IBA"} />
            <SingleSignOnSideBar />
            <main id="main-content">
                <div className="card-box ">
                    <AgentList type="payout" header={payoutheader} />
                    {/* <AccountOpenBarChart />
          <TopPerformerCardAdminParent /> */}
                </div>
            </main>
        </>
    );
}

export default PayoutApproval;
